import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Avatar from '@material-ui/core/Avatar';
import TextField from '@material-ui/core/TextField';
import Container from '@material-ui/core/Container';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { CardHeader } from '@material-ui/core';
import Header from '../layouts/Header';

export interface ForgotPageViewProps {
    saveNewPassword: (newpassword: string) => void;
    saveConfirmPassword: (confirmpassword: string) => void;
    newPassword: string;
    confirmPassword: string;
    typeLink: string;
    onSubmit: () => void;
}

// export const validate = value => {
//     const errors = {};
//     if (!value.newpassword) {
//         errors.newpassword = 'Required';
//     }
//     if (!value.confirmpassword) {
//         errors.confirmpassword = 'Required';
//     }
//     else if (value.newpassword !== value.confirmpassword) {
//         errors.confirmpassword = 'Password mismatched';
//     }
//     return errors;
// };

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            overflow: 'auto'
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
            width: '100%'
        },
        paper: {
            marginTop: theme.spacing(8),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        avatar: {
            margin: theme.spacing(1),
            backgroundColor: theme.palette.secondary.main
        },
        form: {
            width: '100%', // Fix IE 11 issue.
            marginTop: theme.spacing(1),
            textAlign: 'center'
        },
        submit: {
            margin: theme.spacing(3, 1, 2, 1),
            alignItems: 'center'
        },
        rating: {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
    })
);

const ForgotPageView: React.StatelessComponent<ForgotPageViewProps> = props => {
    const classes = useStyles({});

    return (
        <div className={classes.root}>
            <Header />
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <div className={classes.paper}>
                    <CardHeader
                        avatar={
                            <Avatar aria-label="recipe" className={classes.avatar}>
                                <LockOutlinedIcon />
                            </Avatar>}
                        title={<h2>Create New Password</h2>}
                    />
                    <form className={classes.form} noValidate>
                        <FormControl variant="outlined" className={classes.formControl}>
                            <TextField
                                variant="outlined"
                                label="New Password"
                                type="passWord"
                                onChange={event => props.saveNewPassword(event.target.value)}
                                value={props.newPassword}
                            />
                        </FormControl>
                        <FormControl variant="outlined" className={classes.formControl}>
                            <TextField
                                variant="outlined"
                                label="Confirm Password"
                                type="passWord"
                                onChange={event => props.saveConfirmPassword(event.target.value)}
                                value={props.confirmPassword}
                            />
                        </FormControl>
                        <Button
                            type="button"
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            onClick={props.onSubmit}
                        >
                            {props.typeLink === '0' ? <div>Change Password</div> : <div>Create Password</div>}
                        </Button>
                    </form>
                </div>
            </Container>
        </div >
    );
};

export default ForgotPageView;



// WEBPACK FOOTER //
// ./src/components/layouts/ForgotPasswordView.tsx